module.exports = __webpack_public_path__ + "images/follower-042b05.svg";